import React, { useState } from 'react';
import Image from 'next/image';
// import Video from 'next-video';
// import tabimg from "../../public/images/desktopimg3.webp";
// import tabimg1 from "../../public/images/blog02.jpg";
// import tabimg2 from "../../public/images/blog03.jpg";

import layer1 from "../../public/images/layer1.png";
// import solutionsquotesvg from "../../public/svg/solutionsquote.svg";
import darklue from "../../public/images/darkblue1.png";
import SolutionsVideo from './solutionsvideo';


const Solutionscontent = () => {

  // State to manage the sidebar visibility on smaller screens
  const [toggle, setToggle] = useState(false);
  const [openMainSection, setOpenMainSection] = useState("Unique Dashboard");

  const handdleToggle = () => {
    setToggle(!toggle);
  }
  const handleMainSection = (item) => {
    setOpenMainSection(item)
  }
  const menuItems = [
    { id: 1, label: "Unique Dashboard", link: '/uniquedashboard' },
    { id: 2, label: "Dynamic Hiring Process", link: '/dynamichiringprocess' },
    { id: 3, label: "Preplacement Talks", link: '/preplacementtalks' },
    { id: 4, label: "Various Online Assessment", link: '/variousonlineassessment' },
    { id: 5, label: "Personal Online Interview", link: '/personalonlineinterview' },
    { id: 5, label: "Offer Letter", link: '/offerletter' },
  ]
  return (
    <>
      <div className="2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 mt-20 relative">
        <div className='flex justify-center items-center'>
          <h2 className='relative lg:text-4xl text-xl font-[200] z-[10] text-white'>EASYCAMPUS<span className='font-black  tracking-tight'> AT A GLANCE</span></h2>
          <div className='absolute'>
            <Image src={darklue} alt='automate recruiting' width={700} className='h-[90px]'/>
          </div>
        </div>
        <div className='flex justify-center items-center'>
        <div className='grid grid-cols-1 lg:grid-cols-12 mt-16'>
          <div className={`bg-light  flex-col justify-between duration-300 lg:pl-14 col-span-1 lg:col-span-3 ${toggle ? "w-[80px]" : "w-[100%]"} flex-shrink-0`}>
            <div className="flex flex-col items-start my-3 relative bg-gray-50 border-y-4 shadow-lg rounded-lg border-[#1e336a]">
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  className={`flex cursor-pointer selectMenuButton z-10  w-[100%] overflow-hidden whitespace-nowrap ${toggle ? "hidden" : ""} ${openMainSection === item.label ? "border-b-2 active bg-gray-200 mr-3" : "border-b-2"}`}>
                  <div
                    onClick={() => handleMainSection(item.label)}
                    className="flex py-3 px-3 w-full">
                    <div>
                      {!toggle && (
                        <span className={`text-base ${openMainSection === item.label ? "font-bold" : "font-medium"}`}>
                          {item.label}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-grow z-10 lg:pl-10 pl-5 pb-3 pr-14 bg-white flex-basis-0 col-span-1 lg:col-span-9 relative mt-5 lg:mt-0">
            <div className="absolute top-1/2 left-10 transform -translate-y-1/2 h-full w-[0.5px] ml-3 mt-3 hidden lg:block">
              <div className='bg-[#1e336a] h-[20%]'></div>
            </div>
            {openMainSection === "Unique Dashboard" && (
              <div className='lg:ml-24 mt-1'>
                <h1 className="lg:text-xl text-xl font-normal text-[#41b8ea] ">UNIQUE DASHBOARD</h1>
                <h3 className='font-extrabold lg:leading-[45px] tracking-wide lg:text-4xl'>Our unique dashboard provides the,</h3>
                <p className='text-2xl tracking-wider leading-9 mb-2'>Our distinctive dashboard offers a centralized access point for all stakeholders, allowing them to monitor performance and make swift decisions. It also delivers numerous valuable benefits, including:
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  At-a-glance visibility.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Real Time data Access.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Current progress assessment
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Save time and resources.
                </p>
              </div>
            )}
            {openMainSection === "Dynamic Hiring Process" && (
              <div className='lg:ml-24 mt-1'>
                <h1 className="lg:text-xl text-xl font-normal text-[#41b8ea]">Dynamic Campus Planning</h1>
                <h3 className='font-extrabold lg:leading-[45px] tracking-wide lg:text-4xl'>Showcases the adaptability of our platform,</h3>
                <p className='text-2xl tracking-wider leading-9 mb-2'>allowing you to effortlessly customize and modify the campus recruitment process to meet your specific needs. This flexibility empowers you to broaden and diversify your entire campus recruitment pipeline.</p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Campus Response Form Creation.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Define the process timelines.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Interview panel creation.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Separate assessment creation.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Exams creation
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Multiple invitations in one go.
                </p>

              </div>
            )}
            {openMainSection === "Preplacement Talks" && (
              <div className='lg:ml-24 mt-1'>
                <h1 className="lg:text-xl text-xl font-normal text-[#41b8ea]">Pre-Placement Talks,</h1>
                <h3 className='font-extrabold lg:leading-[45px] tracking-wide lg:text-4xl'>However, since every student wants to know</h3>
                <p className='text-2xl tracking-wider leading-9 mb-2'>About the company ans it offers in terms of fair decision making. Our platform provides the easy access to all our stakeholders whosoever they are,</p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can upload the Presentation.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can define the accessibility.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can be seen anytime and from anywhere.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can create the room for video presentation and Q&A.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can define the presentation timeline.
                </p>

              </div>
            )}
            {openMainSection === "Various Online Assessment" && (
              <div className='lg:ml-24 mt-1'>
                <h1 className="lg:text-xl text-xl font-normal text-[#41b8ea]">Various Online Assessment,</h1>
                <h3 className='font-extrabold lg:leading-[45px] tracking-wide lg:text-4xl'>Our online assessment has been designed,</h3>
                <p className='text-2xl tracking-wider leading-9 mb-2'>So correctly and with the right technology to provide quick and fair result on the spot. Our dynamic exam creation provides an edge to keep the stakeholder different from the league and end user experience is to get hassle-free on the spot result.</p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can create the questionnaire data base.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Need not to be dependent upon any third-party integration.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can set the exams timeline.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  On the spot result.
                </p>

              </div>
            )}
            {openMainSection === "Personal Online Interview" && (
              <div className='lg:ml-24 mt-1'>
                <h1 className="lg:text-xl text-xl font-normal text-[#41b8ea]">Personal Online Interview,</h1>
                <h3 className='font-extrabold lg:leading-[45px] tracking-wide lg:text-4xl'>Virtual interview provide the numerous benefits to,</h3>
                <p className='text-2xl tracking-wider leading-9 mb-2'>both the employers and job seekers that includes time and resources and increase the flexibility for all. We have designed our own inbuild too which descrese the dependancy on any third-party intergration and to keep all the information and process so confidential.</p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Automated interview creation.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can define the timeslot for all the interviewees.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can increase or decrease the interview time.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  On screen candidate assessment ratings.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Active Online waiting room.
                </p>

              </div>
            )}
            {openMainSection === "Offer Letter" && (
              <div className='lg:ml-24 mt-1'>
                <h1 className="lg:text-xl text-xl font-normal text-[#41b8ea]">Offer Letter,</h1>
                <h3 className='font-extrabold lg:leading-[45px] tracking-wide lg:text-4xl'> Our automated offer letter process allows,</h3>
                <p className='text-2xl tracking-wider leading-9 mb-2'>the employer to roll out on the spot offer to all successfully selected candidates which reduce friction and streamline the offer process with autofill e-sign technology.</p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Generate e-signed offer letter on a click.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Send offer to all the selected candidates in one go.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Can the see the instant status of the offer letter.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  College/University can get the list of offered candidates.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Students can get the instant offer.
                </p>
                <p className='pt-1 flex'>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 mt-[2px]">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                  </span> &nbsp;&nbsp;
                  Student can Select/Reject the offer immediately.
                </p>

              </div>
            )}

            <SolutionsVideo />
          </div>

        </div>
        </div>
      </div>
    </>
  )
}

export default Solutionscontent 